export default {
    button: {
        signIn: "Logga in",
        forgotPassword: "Glömt lösenord",
        readMore: "Läs mer",
        changePassword: "Byt lösenord",
        reset: "Återställa",
        downloadVerification: "Hämta verifikat",
        downloadVerificationPDF: "Hämta verikat PDF",
        downloadCategoryPDF: "Hämta kategori",
        downloadReportPreview: "Hämta PDF för signering",
        categoryList: "Kategori lista",
        approve: "Överlämna granskning",
        updateProfile: "Uppdatera profil",
        save: "Spara",
        cancel: "Avbryt",
        confirm: "Bekräfta",
        proceedAnyway: "Fortsätt ändå",
        submit: "Slutför granskning",
        sendBack: "Skicka tillbaka",
        requestAttachmentCompletion: "Begär komplettering",
        cancelAttachmentCompletion: "Avbryt komplettering",
        saveReviewNote: "Spara anmärkning",
        saveNotifications: "Spara mottagare",
        removeAttachment: "Ta bort",
        previewAttachment: "Öppna",
        navigate: "Navigera",
        linkGoogle: "Länka Google-leverantör",
        unlinkGoogle: "Ta bort länken till Google",
        changePhoto: "Byt foto",
        removePhoto: "Ta bort foto",
    },
    label: {
        email: "E-post",
        username: "Användarnamn",
        password: "Lösenord",
        repeatPassword: "Repetera lösenord",
        firstName: "Förnamn",
        lastName: "Efternamn",
        currentPassword: "Gammalt lösenord",
        newPassword: "Nytt lösenord",
        repeatNewPassword: "Repetera det nya lösenord",
        showReviewed: "Visa granskade rapporter",
        search: "Sök",
        reviewNote: "Anmärkning",
    },
    placeholder: {
        email: "Ange din e-postadress",
        username: "Ange ditt användarnamn",
        password: "Ange ditt lösenord",
        repeatPassword: "Upprepa ditt lösenord",
        firstName: "Ange ditt förnamn",
        lastName: "Ange ditt efternamn",
        currentPassword: "Ange ditt nuvarande lösenord",
        newPassword: "Ange ditt nya lösenord",
        repeatNewPassword: "Upprepa ditt nya lösenord",
        search: "Sök här...",
        reviewNote: "Skriv en anmärkning (valfritt)",
    },
    navigation: {
        profile: "Profil",
        logout: "Logga ut",
        overview: "Översikt",
        reports: "Rapporter",
        auditedReports: "Färdiggranskade",
        organizationSettings: "Organisationsinställningar",
        helpCenter: "Hjälpcenter",
    },
    reportColumn: {
        name: "Namn",
        principal: "Huvudman",
        trustee: "Ställföreträdare",
        trusteePersonalID: "Ställföreträdare personnummer",
        personalID: "Personnummer",
        type: "Typ",
        reportStart: "Rapport Start",
        reportEnd: "Rapport Slut",
        receivedAt: "Inkommen",
        status: "Status",
        open: "Öppna",
        reviewed: "Granskad",
        notReviwed: "Ej granskad",
        registered: "Registrerad",
    },
    reportVariant: {
        arsrakning: "ÅR",
        slutrakning: "SR",
        forteckning: "FT",
    },
    auditedReportOverview: "Färdiggranskade rapporter",
    messages: {
        success: {
            passwordResetLink: "Länken för återställning av lösenord skickade till %{to}.",
            saveReport: "Rapporten har sparats.",
            updateReport: "Rapporten har uppdaterats.",
            reviewStatusUpdate: "Granskningsstatus uppdaterad: %{status}.",
            profileUpdate: "Profilen har uppdaterats.",
            passwordUpdate: "Lösenordet har uppdaterats.",
            attachmentCompletionRequested: "Begäran om bilagekomplettering skickad.",
            attachmentCompletionCancelled: "Begäran om bilagekomplettering avbruten.",
            complementAcknowledgedSuccess: "Kompletterade bilagor kvitterade.",
            notificationsUpdate: "Aviseringsinställningarna har sparats.",
        },
        info: {
            loadingPreview: "Laddar förhandsvisning...",
            saveDisabledReviewNotes: "Spara anmärkningen i rutan nedan.",
        },
        error: {
            filePreview: "Förhandsgranskningen är begränsad till PDF- och bildfiler.",
            unknownError: "Okänt fel.",
        },
    },
    alert: {
        error: "Något gick fel! Uppdatera sidan och försök igen.",
        form: {
            title: "Dina ändringar kommer att gå förlorade!",
            message:
                "Spara dina ändringar innan du navigerar bort, annars kommer alla ändringar att gå förlorade.",
        },
        report: {
            submit: {
                title: "Bekräfta överlämnande",
                message: "Du håller på att överlämna granskningsbeslutet.",
                notice: "Den signerade bilagan samt granskningsbeslutet måste nu överlämnas till ställföreträdaren manuellt.",
                disclaimer: "OBS: Digitalsignering är under utveckling och kommer att lanseras med det nya lagstödet juli 2026.",
                confirm: "Bekräfta och överlämna",
            },
        },
        reportColumn: {
            register: {
                title: "Är du säker på att du vill markera detta som registrerat?",
            },
            unregister: {
                title: "Är du säker på att du vill markera detta som inte registrerat?",
            },
        },
    },
    reportStatus: {
        0: "Ej granskad",
        1: "Granskad utan anmärkning",
        2: "Granskad med anmärkning",
        3: "Granskad med justering",
        4: "Begär ny rapport för komplettering",
    },
    reportStatusDescription: {
        1: "Rapporten godkänns utan anmärkning",
        2: "Mindre anmärkningar noterade",
        3: "Kräver justeringar innan godkännande",
        4: "Rapporten behöver skickas in på nytt",
    },
    reviewStatusSelect: "Välj granskningsstatus",
    reportReview: {
        sectionTitle: "Anmärkning",
        finalReviewTitle: "Slutför granskning",
        noteHelper: "Lägg till en anmärkning (valfritt).",
        noteLimit: "Max %{max} tecken (%{count}/%{max}), max %{maxLines} radbryt",
        signedUploadTitle: "Spara signerad rapport",
        signedUploadHelper: "Ladda upp och spara den skannade rapporten för dina register.",
        signedUploadButton: "Välj fil",
        signedUploadDisclaimer: "OBS: Filen skickas inte med överlämnandet ännu.",
    },
    notifications: {
        sectionTitle: "Avisering vid inkommen rapport",
        helper: "Vi mejlar när något nytt har inkommit. Mejlet innehåller varken ärende- eller personuppgifter – bara att det finns något att granska, och en länk till portalen.",
        toggleLabel: "Skicka avisering",
        recipientsLabel: "Mottagare",
        recipientsHelper:
            "Ange en eller flera adresser, till exempel er gemensamma funktionsbrevlåda. Tryck Enter efter varje adress.",
        frequencyNote:
            "Flera rapporter som kommer in tätt efter varandra samlas till en avisering.",
    },
    categoryStatus: {
        0: "Ej granskad",
        1: "Granskad",
        2: "Granskad genom stickprov",
        3: "Rimlighetsbedömd",
    },
    validation: {
        notifications: {
            email: {
                invalid: "Ogiltigt e-postformat",
                duplicate: "Adressen finns redan i listan",
            },
            recipients: {
                required: "Ange minst en mottagare när avisering är påslagen",
                max: "Högst %{max} mottagare",
            },
        },
        resetPassword: {
            email: {
                invalid: "E-postadressen är ogiltig",
                required: "E-postadress är obligatorisk",
            },
        },
        signIn: {
            email: {
                invalid: "Ogiltigt e-postformat",
                required: "E-postadress är obligatorisk",
            },
            password: {
                min: "Minst 8 tecken långt",
                required: "Lösenord är obligatoriskt",
            },
        },
        profile: {
            photoURL: {
                nullable: "Ogiltig foto-URL",
            },
            firstName: {
                required: "Förnamn är obligatoriskt",
            },
            lastName: {
                required: "Efternamn är obligatoriskt",
            },
            email: {
                invalid: "Ogiltigt e-postformat",
                nullable: "E-postadressen är ogiltig",
            },
        },
        changePassword: {
            currentPassword: {
                min: "Minst 8 tecken långt",
            },
            newPassword: {
                required: "Nytt lösenord är obligatoriskt",
                min: "Minst 8 tecken långt",
                specialCharacter: "Lösenordet måste innehålla minst ett specialtecken",
                different: "Det nya lösenordet får inte vara detsamma som det nuvarande",
            },
            repeatNewPassword: {
                required: "Bekräfta lösenord är obligatoriskt",
                match: "Lösenorden matchar inte",
            },
            password: {
                min: "Minst 8 tecken långt",
                specialCharacter: "Lösenordet måste innehålla minst ett specialtecken",
            },
            repeatPassword: {
                required: "Bekräfta lösenord är obligatoriskt",
                match: "Lösenorden matchar inte",
            },
        },
    },
    reportOverview: "Rapportöversikt",
    reportPreview: {
        title: "Osignerad rapport",
        description: "Ladda ner för utskrift och signering.",
        dialogTitle: "Välj sidor för signering",
        dialogHelp: "Välj vilka delar som ska ingå i PDF:en.",
        outcomeTitle: "Granskningsval i rapporten",
        outcomes: {
            WITHOUT_REMARKS: "Utan anmärkning",
            WITH_CORRECTION: "Med korrigering",
            WITH_REMARKS: "Med anmärkning",
        },
        pages: {
            FRONT_PAGE: "Förstasida",
            ECONOMIC_SUMMARY: "Ekonomisk sammanställning",
            ASSETS_DEBTS: "Tillgångar och skulder",
            INCOMES_EXPENSES: "Inkomster och utgifter",
            VERIFICATIONS: "Verifikationslista",
            LEDGER: "Kategorispecifikation",
        },
    },
    registryExport: {
        button: "Hämta diarieunderlag",
        dialogTitle: "Diarieunderlag för rapport",
        dialogHelp:
            "Välj vilka sektioner ur rapporten och vilka bilagor som ska ingå. Allt sammanställs till en PDF som ni själva diariför i ert diariesystem.",
        sectionsTitle: "Rapportens sektioner",
        noSectionMap:
            "Rapporten skickades in innan sektionsval stöddes — hela rapporten följer med.",
        attachmentsTitle: "Bilagor",
        attachmentsHelp: "Valda bilagor konverteras till PDF och läggs sist i dokumentet.",
        download: "Ladda ner underlag",
    },
    result: "resultat",
    rowsPerPage: "Resultat per sida",
    of: "av",
    personalData: "Personuppgifter",
    annualReport: "Årsräkning, bilagor",
    complementAttachments: "Inkomna kompletteringar",
    complementReceived: "Inkomna kompletteringar",
    completionRequested: "Bilagekomplettering begärd",
    acknowledgeComplement: "Kvittera komplettering",
    complementAcknowledged: "Kvitterad",
    complementReceivedMessage: "Kompletteringar har inkommit. Kvittera för att bekräfta att kompletteringarna är mottagna.",
    acknowledgeComplementTitle: "Kvittera komplettering?",
    acknowledgeComplementDescription: "Du bekräftar att de kompletterande bilagorna har granskats och tagits emot. Kompletteringsmarkeringen tas bort från rapportlistan.",
    acknowledgeComplementConfirm: "Ja, kvittera",
    noComplementAttachments: "Inga inkomna kompletteringar",
    requestComplementTitle: "Begär komplettering?",
    requestComplementDescription: "Detta skickar en begäran om komplettering av bilagor. Observera att ställföreträdaren inte notifieras automatiskt – du behöver själv kontakta ställföreträdaren och meddela att komplettering har begärts.",
    requestComplementConfirm: "Ja, begär komplettering",
    economicOverview: "Ekonomisk översikt",
    assetsAndLiabilities: "Tillgångar och skulder",
    preview: "Granskningsöversikt",
    incomings: "Inkomster",
    outgoings: "Utgifter",
    debts: "Skulder",
    category: "Kategori",
    amount: "Summa",
    comment: "Kommentar",
    status: "Status",
    caseOverview: "Ärendeöversikt",
    difference: "Differens",
    incomeDuringPeriod: "Inkomster under perioden",
    expenseDuringPeriod: "Utgifter under perioden",
    bankFundsAsOf: "Bankmedel per %{date}",
    transactionAccounts: "Transaktionskonton",
    account: "Konto",
    accountNumber: "Kontonummer",
    otherBankAccounts: "Övriga bankkonton och tillgångar",
    type: "Typ",
    description: "Beskrivning",
    sumA: "Summa A",
    sumD: "Summa D",
    date: "Datum",
    importSource: "Källa",
    importSourceBank: "Bankkoppling",
    importSourceFile: "Fil",
    importSourceManual: "Manuell",
    balance: "Saldo",
    download: "Ladda ner",
    downloading: "Laddar ner",
    downloaded: "Nedladdad",
    startDate: "Start Datum",
    endDate: "Slutdatum",
    selectDateRange: "Välj datumintervall",
    clearFilter: "Rensa filter",
    verificationList: "Verifikationslista",
    CategoryList: "Kategorilista",
    verification: "Verifikat",
    tag: "Tagg",
    taxDeduction: "Avdragen skatt",
    selectCategories: "Välj Kategorier",
    categorySpecification: "Kategorispecifikation",
    chooseMunicipality: "Välj kommun",
    yourMunicipalities: "Dina kommuner",
};
